/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'computer': {
    width: 12,
    height: 10,
    viewBox: '0 0 12 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12 .839v7.349a.759.759 0 01-.774.705h-3.66c.282.335.563.369 1.02.47.388.067.388.637-.035.637H3.413c-.422 0-.422-.57 0-.638.423-.067.74-.134 1.021-.47H.774C.352 8.893 0 8.592 0 8.189V.838C0 .37.387 0 .88 0h10.24c.493 0 .88.37.88.839zm-5.49 7.45c.247 0 .247-.504 0-.504H5.49c-.247 0-.247.504 0 .504h1.02zm4.61-1.175c.106 0 .141-.067.141-.134V.839c0-.1-.035-.168-.14-.168H.88C.774.671.704.738.704.84v6.14c0 .068.07.135.176.135h10.24z" _fill="#1988EF"/>'
  }
})
